// extracted by mini-css-extract-plugin
module.exports = {"base":"Hotspot_base__3KWwH","bubble":"Hotspot_bubble__1OpCK","focus":"Hotspot_focus__1BuuF"};